import renderAlertThresholdModal from "../../../infrastructure/renders/AlertThresholdModal/render-alert-threshold-modal";

export default function showAlertThresholdModal(props) {
  renderAlertThresholdModal(props);
}
